// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/typographyStyle
import { section, title } from 'styles/jss/original/base';

const styles = {
  section,
  title: {
    ...title,
    marginTop: '0'
  }
};

export default styles;
